import { Outlet } from 'react-router-dom';
import { CircularProgress } from '@mui/material';

export default function LandingPage({
  loading,
  isUserVerified,
}: {
  loading: boolean;
  isUserVerified: boolean;
}) {
  if (loading) {
    return <CircularProgress />;
  }
  return isUserVerified ? (
    <Outlet />
  ) : (
    <div
      style={{
        position: 'absolute',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '80%',
      }}
    >
      <h1>Verify your account!</h1>
      <p>
        Please look for a verification email in your inbox or spam and verify so
        you can access all features.
      </p>
    </div>
  );
}
